module.exports = __webpack_public_path__ + "assets/flag.975b0ed1.svg";